import Section from "../Section"
import { split, support } from "../utils"
import gsap from "gsap";
import { CustomEase } from "gsap/CustomEase"
gsap.registerPlugin(CustomEase)

class AboutImage extends Section {
  constructor(opts) {
    super(opts)

    if (support.touch) return

    this.DOM = this.getDOM()

    this.imageTL = this.createTransformImageTL()

    this.data.height = 400 // hardcode an image height because im lazy
  }

  getDOM() {
    return {
      imageOverflow: this.section.querySelector(".about__image--lower .about__image-overflow"),
      image: this.section.querySelector(".about__image--lower img")
    }
  }

  createTransformImageTL() {
    const tl = new gsap.timeline({ paused: true })

    tl
      .fromTo(this.DOM.imageOverflow, { x: 0 }, { x: -70, ease: "Linear.easeNone" }, 0)
      .fromTo(this.DOM.image, { scale: 1.1 }, { scale: 1, ease: "Linear.easeNone" }, 0)

    return tl
  }

  run(opts) {
    super.run(opts)
    this.imageTL.progress(this.data.progress)
  }
}

export default AboutImage